import clearSessionStorageJwtKey from 'actions/clearSessionStorageJwtKey';
import removeJwt from 'actions/removeJwt';

const logout = async () => {
  await removeJwt();
  await clearSessionStorageJwtKey();
  window.location.href = '/logout?referrer=unauthorized';
};

export default logout;
